import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { SeoService } from './core/services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // Fallbacks from index.html, used when a route has no SEO data of its own
  private readonly defaultTitle = this.title.getTitle();
  private readonly defaultDescription = this.meta.getTag('name="description"')?.content ?? '';

  constructor(router: Router, private title: Title, private meta: Meta, private seo: SeoService) {
    // Apply each route's `data: { title, description, keywords }` plus a canonical
    // link to the same path on ghru.edu.in.
    router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.applySeo(router.routerState.snapshot.root, event.urlAfterRedirects));
  }

  private applySeo(root: ActivatedRouteSnapshot, url: string): void {
    let route = root;
    while (route.firstChild) route = route.firstChild;
    const data = route.data;

    // Course, blog and event pages build their SEO from content and have already
    // set it in their own init (which runs before NavigationEnd): leave it alone.
    if (!data['title'] && (data['slug'] || route.paramMap.has('slug'))) return;

    this.seo.update({
      title: data['title'] || this.defaultTitle,
      description: data['description'] || this.defaultDescription,
      canonical: this.seo.urlFor(url)
    });
    if (data['keywords']) {
      this.meta.updateTag({ name: 'keywords', content: data['keywords'] });
    } else {
      this.meta.removeTag('name="keywords"');
    }
  }
}
